import { gql } from '@apollo/client';

// Hand-written beside the generated documents: `npm run generate` rewrites queries.ts and mutations.ts, never this file.

const TRACEABILITY_LABEL_FIELDS = gql`
  fragment TraceabilityLabelFields on Label {
    id
    itemId
    itemName
    unit
    qty
    balance
    childCount
    parentId
    supplierRef
    createdAt
    registeredAt
  }
`;

export const TRACEABILITY_LABELS_QUERY = gql`
  ${TRACEABILITY_LABEL_FIELDS}
  query TraceabilityLabels($kitchen: Kitchen!, $from: AWSDate!, $to: AWSDate!, $itemId: String, $limit: Int, $next: String) {
    listLabels(kitchen: $kitchen, from: $from, to: $to, itemId: $itemId, limit: $limit, next: $next) {
      items {
        ...TraceabilityLabelFields
      }
      next
    }
  }
`;

export const TRACEABILITY_CHILD_LABELS_QUERY = gql`
  ${TRACEABILITY_LABEL_FIELDS}
  query TraceabilityChildLabels($kitchen: Kitchen!, $parentId: String!) {
    listChildLabels(kitchen: $kitchen, parentId: $parentId) {
      ...TraceabilityLabelFields
    }
  }
`;

export const TRACEABILITY_LABEL_QUERY = gql`
  ${TRACEABILITY_LABEL_FIELDS}
  query TraceabilityLabel($kitchen: Kitchen!, $id: String!) {
    getLabel(kitchen: $kitchen, id: $id) {
      label {
        ...TraceabilityLabelFields
      }
      ancestors {
        ...TraceabilityLabelFields
      }
      children {
        ...TraceabilityLabelFields
      }
    }
  }
`;

export const TRACEABILITY_SCAN_LABEL_MUTATION = gql`
  ${TRACEABILITY_LABEL_FIELDS}
  mutation TraceabilityScanLabel($input: ScanLabelInput!) {
    scanLabel(input: $input) {
      label {
        ...TraceabilityLabelFields
      }
      registered
    }
  }
`;
